import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const STORAGE_KEY = 'dspDomainNames'
const TIMESTAMP_KEY = 'dspDomainNamesTimestamp'
const EXPIRATION_TIME = 60 * 60 * 1000

export default {
  namespaced: true,
  state: {
    domainNames: JSON.parse(localStorage.getItem(STORAGE_KEY)) || [],
  },
  getters: {
    domains: state => {
      const lastSavedTime = localStorage.getItem(TIMESTAMP_KEY)
      const currentTime = Date.now()

      if (!lastSavedTime || Number.isNaN(lastSavedTime) || currentTime - Number(lastSavedTime) > EXPIRATION_TIME) {
        return []
      }

      return state.domainNames
    },
    domainNameByIdFromStore: state => domainId => {
      const lastSavedTime = localStorage.getItem(TIMESTAMP_KEY)
      const currentTime = Date.now()

      if (!lastSavedTime || Number.isNaN(lastSavedTime) || currentTime - Number(lastSavedTime) > EXPIRATION_TIME) {
        return domainId
      }

      const domain = state.domainNames.find(d => d.id === domainId)
      return domain ? domain.name : domainId
    },
  },
  mutations: {
    ADD_DOMAIN_NAMES(state, domainsObject) {
      const currentIds = new Set(state.domainNames.map(domain => domain.id))

      // Convert object format to array format
      const newDomains = Object.entries(domainsObject).map(([id, name]) => ({
        id,
        name,
      }))

      newDomains.forEach(newDomain => {
        if (!currentIds.has(newDomain.id)) {
          state.domainNames.push(newDomain)
        }
      })

      localStorage.setItem(STORAGE_KEY, JSON.stringify(state.domainNames))
      localStorage.setItem(TIMESTAMP_KEY, Date.now().toString())
    },
  },
  actions: {
    async fetchDomainNamesById({ commit, state }, { dspId, siteIds }) {
      const lastSavedTime = localStorage.getItem(TIMESTAMP_KEY)
      const timestamp = Number(lastSavedTime)
      const currentTime = Date.now()

      if (!lastSavedTime || Number.isNaN(timestamp) || currentTime - timestamp > EXPIRATION_TIME) {
        try {
          const response = await useJwt.domainNamesById({ dsp_id: dspId, site_ids: siteIds })
          commit('ADD_DOMAIN_NAMES', response.data)
        } catch (error) {
          if (error.response && error.response.status === 422 && error.response.data.errors.length) {
            error.response.data.errors.forEach(err => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Error',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                  text: err.detail,
                },
              })
            })
          }
        }
      } else {
        const missingIds = siteIds.filter(id => !state.domainNames.some(domain => domain.id === id))

        if (missingIds.length === 0) {
          return
        }

        try {
          const response = await useJwt.domainNamesById({ dsp_id: dspId, site_ids: missingIds })
          commit('ADD_DOMAIN_NAMES', response.data)
        } catch (error) {
          if (error.response && error.response.status === 422 && error.response.data.errors.length) {
            error.response.data.errors.forEach(err => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Error',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                  text: err.detail,
                },
              })
            })
          }
        }
      }
    },
  },
}
